<template>
  <div>
    <h3 style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
      网站管理员
    </h3>
    <el-button type="primary" @click="dialogFormVisible = true;form = {}" style="float:left;" plain>新增</el-button>
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%">
        <el-table-column
          prop="username"
          label="登录帐号">
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="管理员名称">
        </el-table-column>
        <el-table-column
          prop="createtime"
          label="创建时间">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
          </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加网站管理员" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="登录帐号：" :label-width="formLabelWidth">
          <el-input v-model="form.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="管理员名称：	" :label-width="formLabelWidth">
          <el-input v-model="form.nickname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码：" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" :label-width="formLabelWidth">
          <el-input v-model="form.password2" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    export default {
      name: "UserList",
      methods: {
        submit(){
          const self = this
          if(this.form.password){

          }
          let postData = self.$qs.stringify(this.form)
          let method = 'save'
          if(this.form.id){
            method = 'update'
          }
          self.$http.post(self.$host+'user/'+method,
            postData
          ).then(function (response) {
            self.$common.loginCheck(response.data.content)
            self.dialogFormVisible = false
            self.loadData()
          }).catch(e => {
            console.log(e)
          })
        },
        handleEdit(row){
          // 这里需要把row的数据拷贝一份，不然在编辑栏编辑的时候回改动列表的数据
          this.form = JSON.parse(JSON.stringify(row))
          this.dialogFormVisible = true;
        },
        handleDelete(row){
          this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const self = this
            let postData = self.$qs.stringify(row)
            self.$http.post(self.$host+'user/delete',
              postData
            ).then(function (response) {
              self.$common.loginCheck(response.data.content)
              // self.tableData = response.data.list;
              self.dialogFormVisible = false
              self.loadData()
            }).catch(e => {
              console.log(e)
            })
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        },
        loadData(params) {
          const self = this
          let postData =
            self.$qs.stringify({
            })
          self.$http.post(self.$host+'user/list',
            postData
          ).then(function (response) {
            console.log(response.data.content)
            self.tableData = response.data.content;
          }).catch(e => {
            console.log(e)
          })
        }
      },
      mounted() {
        this.$nextTick(() => {
          this.loadData();
        })
      },
      data() {
        return {
          tableData:[],
          dialogTableVisible: false,
          dialogFormVisible: false,
          form: {},
          formLabelWidth: '120px',
          value4: true,
        };
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/UserManage.vue